import React from "react";
import "../assets/style.css";
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { Helmet } from "react-helmet-async";
import header from '../assets/img/oasis/aboutheader.jpg';
import classroom from '../assets/img/oasis/classroomtv.jpg';
import lab from '../assets/img/oasis/aboutLab.jpg';
import library from '../assets/img/oasis/library.jpg';
import conferenceroom from '../assets/img/oasis/conferenceroom.jpg';
import playground from '../assets/img/oasis/playground.jpg';
import schoolbuses from '../assets/img/oasis/schoolbuses.jpg';




const AboutScreen = () => {
    return <>
        <Helmet>
            <title>About</title>
            <meta name="description" content="This is the About Page of Oasis Educational Institute" />
        </Helmet>
        <Breadcrumbs page="About Us" label="Home" path="/" />

        <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-12 px-4 sm:px-6 lg:px-8">

            <div className="max-w-7xl mx-auto text-center mb-12">
                <img
                    src={header}
                    alt="OASIS Educational Institute"
                    className="w-full h-64 object-cover rounded-lg mb-8"
                />
                <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl">
                    About OASIS Educational Institute
                </h1>
                <p className="mt-4 text-xl text-gray-600">
                    Nurturing the all-round development of children through excellence in education.
                </p>
            </div>

            {/* Vision and Mission Section */}
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">

                    <h2 className="text-2xl font-bold text-blue-900 mb-4">Our Vision</h2>
                    <p className="text-gray-700">
                        To create a safe, inclusive, and stimulating learning environment where every child can
                        thrive academically, socially, and emotionally.
                    </p>
                </div>
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">

                    <h2 className="text-2xl font-bold text-purple-900 mb-4">Our Mission</h2>
                    <p className="text-gray-700">
                        To provide a holistic education that equips students with essential skills in literacy,
                        numeracy, cognition, and social interaction, preparing them to excel in an ever-changing
                        world.
                    </p>
                </div>
            </div>

            {/* Campus Facilities Section */}
            <div className="max-w-7xl mx-auto mb-12">
                <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Our Campus</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {[
                        { text: "60 well-ventilated, smart classrooms", img: classroom },
                        { text: "Specialized labs for Science, Math, and Language", img: lab },
                        { text: "Art rooms, computer labs, and libraries", img: library },
                        { text: "Activity rooms, conference rooms, and auditorium", img: conferenceroom },
                        { text: "Swimming pool, playground, and sports fields", img: playground },
                        { text: "Dedicated school buses for all routes in Srinagar", img: schoolbuses},
                    ].map((facility, index) => (
                        <div
                            key={index}
                            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                        >
                            <img
                                src={facility.img}
                                alt={facility.text}
                                className="w-full h-48 object-cover rounded-t-lg mb-4"
                            />
                            <p className="text-gray-700">{facility.text}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Core Beliefs Section */}
            <div className="max-w-7xl mx-auto mb-12">
                <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Core Beliefs</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {[
                        {
                            title: "Holistic Development",
                            description: "Education goes beyond academics; it encompasses physical, emotional, and social growth.",
                        },
                        {
                            title: "Student-Centered Learning",
                            description: "Every child is unique, and our teaching methods are tailored to meet individual needs.",
                        },
                        {
                            title: "Inclusivity",
                            description: "We welcome students from diverse backgrounds and strive to create an inclusive community.",
                        },
                        {
                            title: "Excellence",
                            description: "We are committed to maintaining high standards in education and infrastructure.",
                        },
                    ].map((belief, index) => (
                        <div
                            key={index}
                            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                        >

                            <h3 className="text-xl font-bold text-blue-900 mb-3">{belief.title}</h3>
                            <p className="text-gray-700">{belief.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Pupil Care Section */}
            <div className="max-w-7xl mx-auto">
                <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Pupil Care</h2>
                <div className="bg-white p-8 rounded-lg shadow-lg">
                    <p className="text-gray-700">
                        At OASIS, the well-being of our students is our top priority. We provide a supportive
                        and nurturing environment where every child feels valued and encouraged to reach their
                        full potential.
                    </p>
                </div>
            </div>
        </div>
    </>
};

export default AboutScreen;